"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_document__png(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dbbbd7b7-110a-4505-8442-23c616d816e5",
    x1: 125.08,
    y1: 44.36,
    x2: 159.64,
    y2: 78.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "document-png-hi"), /*#__PURE__*/React.createElement("g", {
    id: "4b316e1c-a65e-43cb-a8fe-af0663f16700",
    "data-name": "document-png-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5206a441-7b98-4d85-aa80-14a842c7cfd6",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c8ddc035-3638-4466-8a80-cd2a0b8eb357",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "149a3ba9-fdc5-41f7-9fd7-b181445a3b2b",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "79baff55-01c2-4960-a3c5-3afe3ca577b5",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4eb9ae38-09bf-4d90-a08f-a7697f760a83",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3e92564d-050b-4359-a67e-168d670f69c0",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8104d623-7bb5-4af4-8f10-5c82c21c8f18",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "87cf0f26-943e-4e3d-8b78-e156575f6bf7",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5ed6bcdd-7357-47f0-b628-9cbe2c84e336",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2f54f386-b138-4fc4-b885-11161b007a88",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02db3162-3fa1-4dc6-9cf2-557bb1919ea9",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6692165b-dcf5-443b-b7cf-4faa881e51e3",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2e827664-49f5-4f15-8fe4-5c1451834fad",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4957864a-bca3-4953-92b2-3253be45468e",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0e485c1b-855c-400c-b54e-6d388988e5b1",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c54b01fc-e306-4300-89f4-c4caa35e1ac7",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "56b6c45f-53a0-44f2-899c-e80c8c16ddc1",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a493716a-60df-4758-9bfd-dc9f85e6040a",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7ba08d55-fb7b-48c4-bf32-b337d530def5",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1555877c-8bda-4cee-8ec0-3e80edc02ce2",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ea2465db-e83f-42eb-a367-75bad921d595",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cc1f0690-d40e-46e4-88c9-36091921d3b4",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4e1c9b6c-dc4d-458d-a529-d19e814fc50a",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "82664a93-943f-4329-8927-061315bc8c03",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d7276926-c8f2-471e-b210-8913fad8611b",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f3cc2f5f-03cc-4a2e-bc7c-41147f63ef55",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7781c6b8-4b27-4077-88ae-3f35f1a43c44",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bad561a7-342b-4858-8232-daccd68792db",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,44V160h0a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16h0V56H128a16,16,0,0,1-16-16V16H56A16,16,0,0,0,40,32V44",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,56H128a16,16,0,0,1-16-16V16Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,54a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h24l-2-2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,56c-.53,0-1.05,0-1.57-.08l-.62-.09c-.3,0-.6-.08-.89-.14s-.53-.12-.79-.19l-.65-.17c-.3-.09-.6-.2-.9-.3l-.47-.17c-.33-.13-.65-.28-1-.43l-.32-.16c-.35-.17-.68-.36-1-.56l-.2-.12q-.54-.33-1-.7l-.09-.07c-.36-.27-.71-.55-1-.84h0L152,86.56V56Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#dbbbd7b7-110a-4505-8442-23c616d816e5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,174H56a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16v-2A16,16,0,0,1,136,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.35,125.58a2.73,2.73,0,0,1-2.3-1,3.45,3.45,0,0,1-.77-2.17,3.52,3.52,0,0,1,.77-2.21,2.73,2.73,0,0,1,2.3-1,2.67,2.67,0,0,1,2.28,1,3.59,3.59,0,0,1,.75,2.21,3.52,3.52,0,0,1-.75,2.17A2.67,2.67,0,0,1,52.35,125.58Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,125.1V95.87h8.77a25,25,0,0,1,3.9.28,11.89,11.89,0,0,1,3.46,1.12,6.68,6.68,0,0,1,3.11,3.13,10.08,10.08,0,0,1,1,4.45,10.75,10.75,0,0,1-.75,4,8.72,8.72,0,0,1-1.86,3,7.74,7.74,0,0,1-2.3,1.64,13.44,13.44,0,0,1-3,.85,18.86,18.86,0,0,1-3,.24H65.67V125.1Zm5.52-15.56h3.11a16.45,16.45,0,0,0,2.17-.13,5.34,5.34,0,0,0,1.69-.48,3.61,3.61,0,0,0,1.71-1.58,4.67,4.67,0,0,0-.07-4.43,3.26,3.26,0,0,0-1.78-1.49,10.79,10.79,0,0,0-3.51-.53H65.67Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.21,125.1V95.87H90l11.26,18.23V95.87h5.52V125.1h-4.91L89.78,105.77V125.1Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.76,125.72a13.34,13.34,0,0,1-5.24-1,11.13,11.13,0,0,1-4.1-3,13.75,13.75,0,0,1-2.65-4.75,20,20,0,0,1-.94-6.4,20.61,20.61,0,0,1,1-6.82A14,14,0,0,1,115.55,99a10.8,10.8,0,0,1,3.92-2.83,13.28,13.28,0,0,1,10.85.5,9.62,9.62,0,0,1,3.64,3.66l-3.86,3.55a7.26,7.26,0,0,0-1.4-1.77,6.22,6.22,0,0,0-2.06-1.23,7,7,0,0,0-2.45-.46,5.42,5.42,0,0,0-3.64,1.4,7.75,7.75,0,0,0-2.32,3.79,17.57,17.57,0,0,0-.7,5,13.34,13.34,0,0,0,1.18,5.81,6.46,6.46,0,0,0,2.94,3.29,8.1,8.1,0,0,0,3.42.81,16.23,16.23,0,0,0,2.83-.2,7.72,7.72,0,0,0,1.25-.28v-5.26h-4.56v-5h9.82v14.07a12.68,12.68,0,0,1-3.59,1.32A25.71,25.71,0,0,1,124.76,125.72Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  })))))))))))))))))))))))))))))));
}

var _default = ic_document__png;
exports.default = _default;